if (!customElements.get('pdp-kb-gallery')) {
  customElements.define(
    'pdp-kb-gallery',
    class PdpKbGallery extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('[data-track]');
        this.thumbWrap = this.querySelector('[data-thumbs]');
        this.prev = this.querySelector('[data-prev]');
        this.next = this.querySelector('[data-next]');
        this.index = 0;
        this.initLightbox();
        if (!this.track) return;

        this.prev && this.prev.addEventListener('click', () => this.goTo(this.index - 1));
        this.next && this.next.addEventListener('click', () => this.goTo(this.index + 1));
        this.thumbWrap && this.thumbWrap.addEventListener('click', (e) => {
          const t = e.target.closest('[data-thumb]');
          const i = t ? this.thumbs.indexOf(t) : -1;
          if (i > -1) this.goTo(i);
        });

        let raf;
        this.track.addEventListener('scroll', () => {
          cancelAnimationFrame(raf);
          raf = requestAnimationFrame(() => this.syncFromScroll());
        }, { passive: true });

        this.refresh();
      }
      refresh() {
        this.slides = Array.from(this.querySelectorAll('[data-slide]')).filter((s) => !s.hidden);
        this.thumbs = Array.from(this.querySelectorAll('[data-thumb]')).filter((t) => !t.hidden);
        const multi = this.slides.length > 1;
        [this.prev, this.next].forEach((b) => { if (b) b.hidden = !multi; });
        if (this.thumbWrap) this.thumbWrap.hidden = !multi;
        this.index = Math.max(0, Math.min(this.index, this.slides.length - 1));
        this.update();
      }
      initLightbox() {
        const dlg = this.querySelector('[data-lightbox]');
        if (!dlg) return;
        let data = [];
        try { data = JSON.parse(dlg.querySelector('[data-lb-data]').textContent); } catch (e) { return; }
        const img = dlg.querySelector('[data-lb-img]');
        const stage = dlg.querySelector('[data-lb-stage]');
        const count = dlg.querySelector('[data-lb-count]');
        let cur = 0;
        let zoomed = false;
        let base = null;
        const scale = 2.5;

        const setOrigin = (x, y) => {
          const r = base || img.getBoundingClientRect();
          const ox = Math.min(100, Math.max(0, ((x - r.left) / r.width) * 100));
          const oy = Math.min(100, Math.max(0, ((y - r.top) / r.height) * 100));
          img.style.transformOrigin = ox + '% ' + oy + '%';
        };
        const unzoom = () => {
          zoomed = false;
          base = null;
          dlg.classList.remove('is-zoomed');
          img.style.transform = '';
        };
        const show = (i) => {
          cur = (i + data.length) % data.length;
          unzoom();
          img.src = data[cur].src;
          img.alt = data[cur].alt || '';
          if (count) count.textContent = data.length > 1 ? (cur + 1) + ' / ' + data.length : '';
        };
        const open = (i) => {
          show(i);
          document.documentElement.classList.add('pdp-kb-lock');
          if (typeof dlg.showModal === 'function') dlg.showModal(); else dlg.setAttribute('open', '');
        };
        const close = () => {
          unzoom();
          document.documentElement.classList.remove('pdp-kb-lock');
          if (dlg.open && typeof dlg.close === 'function') dlg.close(); else dlg.removeAttribute('open');
        };

        this.querySelectorAll('[data-zoom-open]').forEach((btn) => {
          btn.addEventListener('click', () => open(Number(btn.dataset.zoomOpen)));
        });
        dlg.querySelector('[data-lb-close]').addEventListener('click', close);
        const prev = dlg.querySelector('[data-lb-prev]');
        const next = dlg.querySelector('[data-lb-next]');
        prev && prev.addEventListener('click', () => show(cur - 1));
        next && next.addEventListener('click', () => show(cur + 1));
        dlg.addEventListener('close', () => { unzoom(); document.documentElement.classList.remove('pdp-kb-lock'); });
        dlg.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowLeft') show(cur - 1);
          if (e.key === 'ArrowRight') show(cur + 1);
        });

        img.addEventListener('click', (e) => {
          if (zoomed) { unzoom(); return; }
          base = img.getBoundingClientRect();
          setOrigin(e.clientX, e.clientY);
          zoomed = true;
          dlg.classList.add('is-zoomed');
          img.style.transform = 'scale(' + scale + ')';
        });
        stage.addEventListener('mousemove', (e) => { if (zoomed) setOrigin(e.clientX, e.clientY); });
        stage.addEventListener('touchmove', (e) => {
          if (zoomed && e.touches.length === 1) { e.preventDefault(); setOrigin(e.touches[0].clientX, e.touches[0].clientY); }
        }, { passive: false });
        stage.addEventListener('click', (e) => { if (e.target === stage && !zoomed) close(); });

        let sx = null;
        stage.addEventListener('touchstart', (e) => { sx = !zoomed && e.touches.length === 1 ? e.touches[0].clientX : null; }, { passive: true });
        stage.addEventListener('touchend', (e) => {
          if (sx === null || zoomed) return;
          const dx = e.changedTouches[0].clientX - sx;
          if (Math.abs(dx) > 50) show(cur + (dx < 0 ? 1 : -1));
          sx = null;
        });
      }
      step() {
        if (this.slides.length < 2) return this.track.clientWidth;
        return this.slides[1].offsetLeft - this.slides[0].offsetLeft;
      }
      goTo(i) {
        const max = this.slides.length - 1;
        this.index = Math.max(0, Math.min(max, i));
        this.track.scrollTo({ left: this.slides[this.index].offsetLeft - this.slides[0].offsetLeft, behavior: 'smooth' });
        this.update();
      }
      syncFromScroll() {
        const i = Math.round(this.track.scrollLeft / this.step());
        if (i !== this.index) {
          this.index = Math.max(0, Math.min(this.slides.length - 1, i));
          this.update();
        }
      }
      update() {
        if (!this.slides || !this.slides.length) return;
        this.thumbs.forEach((t, n) => {
          if (n === this.index) {
            t.setAttribute('aria-current', 'true');
            if (this.thumbWrap) {
              const l = t.offsetLeft - this.thumbWrap.offsetLeft;
              if (l < this.thumbWrap.scrollLeft || l + t.offsetWidth > this.thumbWrap.scrollLeft + this.thumbWrap.clientWidth) {
                this.thumbWrap.scrollTo({ left: l - 16, behavior: 'smooth' });
              }
            }
          } else {
            t.removeAttribute('aria-current');
          }
        });
        if (this.prev) this.prev.disabled = this.index === 0;
        if (this.next) this.next.disabled = this.index === this.slides.length - 1;
      }
    }
  );
}

/* Produktbeschreibung: „Mehr anzeigen“ */
(function () {
  const init = (root) => {
    root.querySelectorAll('.pdp-ms [data-desc]').forEach((body) => {
      if (body.dataset.descInit) return;
      body.dataset.descInit = '1';
      const content = body.querySelector('[data-desc-content]');
      const more = body.querySelector('[data-desc-more]');
      if (!content || !more) return;
      const lessLabel = 'Weniger anzeigen';
      const moreLabel = more.textContent.trim();
      const check = () => {
        if (body.classList.contains('is-expanded')) return;
        const clipped = content.scrollHeight > content.clientHeight + 2;
        more.hidden = !clipped;
        body.classList.toggle('no-clip', !clipped);
      };
      more.addEventListener('click', () => {
        const open = body.classList.toggle('is-expanded');
        more.textContent = open ? lessLabel : moreLabel;
        more.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      check();
      window.addEventListener('resize', check, { passive: true });
    });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();

/* Musterbox nur einmal pro Bestellung */
(function () {
  const base = window.Shopify && Shopify.routes ? Shopify.routes.root : '/';
  const cartUrl = base + 'cart.js';
  const origFetch = window.fetch.bind(window);
  const buttons = [];
  let timer = null;

  const setState = (btn, inCart) => {
    const label = btn.querySelector('span');
    if (inCart) {
      btn.dataset.inCart = 'true';
      btn.dataset.locked = 'true';
      btn.disabled = true;
      if (label) label.textContent = btn.dataset.labelInCart;
    } else {
      delete btn.dataset.inCart;
      delete btn.dataset.locked;
      if (btn.dataset.available === 'true') {
        btn.disabled = false;
        if (label) label.textContent = btn.dataset.labelAtc;
      }
    }
  };

  const checkAll = () => {
    if (!buttons.length) return;
    clearTimeout(timer);
    timer = setTimeout(() => {
      origFetch(cartUrl, { cache: 'no-store' })
        .then((r) => r.json())
        .then((cart) => {
          buttons.forEach((btn) => {
            const id = Number(btn.dataset.variantId);
            setState(btn, cart.items.some((i) => i.variant_id === id));
          });
        })
        .catch(() => {});
    }, 300);
  };

  /* Jede Warenkorb-Änderung des Themes (Hinzufügen, Entfernen, Menge ändern) löst einen Abgleich aus */
  window.fetch = function (input) {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    const request = origFetch.apply(window, arguments);
    if (/\/cart\/(add|change|update|clear)/.test(url)) {
      request.then(checkAll, checkAll);
    }
    return request;
  };

  const init = (scope) => {
    scope.querySelectorAll('.pdp-ms [data-once-btn]').forEach((btn) => {
      if (btn.dataset.onceInit) return;
      btn.dataset.onceInit = '1';
      buttons.push(btn);

      /* Das Theme schaltet den Knopf nach dem Hinzufügen wieder frei – dann erneut sperren */
      new MutationObserver(() => {
        if (btn.dataset.locked === 'true' && !btn.disabled) btn.disabled = true;
      }).observe(btn, { attributes: true, attributeFilter: ['disabled'] });

      const form = btn.closest('form');
      if (form) {
        form.addEventListener('submit', (e) => {
          if (btn.dataset.inCart === 'true') {
            e.preventDefault();
            e.stopImmediatePropagation();
            return;
          }
          btn.dataset.inCart = 'true';
        }, true);
      }
    });
    checkAll();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }
  window.addEventListener('pageshow', checkAll);
  document.addEventListener('visibilitychange', () => { if (!document.hidden) checkAll(); });
})();